export default __webpack_public_path__ + "static/media/Hockey_04.75d770ad.png";